import React from 'react';
import { useUser } from '@lore/auth';
import { Helmet } from 'react-helmet-async';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';
import useIntents from '../../../hooks/useIntents';

export default function Layout(props) {
  const { history } = useRouter();
  const user = useUser();

  const navigation = useSetupNavigation(Urls.PARTNER_VALUE_NO);

  const { isEducator, isPartner } = useIntents();

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Value</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls.PARTNER_INTENT)}
        onNext={() => isEducator ? history.push(Urls.SKILLS_INTRODUCTION) : history.push(Urls.ORGANIZATION)}
        onSkip={() => isEducator ? history.push(Urls.SKILLS_INTRODUCTION) : history.push(Urls.ORGANIZATION)}
      />
    </ParentLayout>
  );
};
